var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "unlock-fill",
    clipPath: "url(#clip0_2849_6618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5 1.5C15.7044 1.5 14.9413 1.81607 14.3787 2.37868C13.8161 2.94129 13.5 3.70435 13.5 4.5V10.5C14.2956 10.5 15.0587 10.8161 15.6213 11.3787C16.1839 11.9413 16.5 12.7044 16.5 13.5V21C16.5 21.7956 16.1839 22.5587 15.6213 23.1213C15.0587 23.6839 14.2956 24 13.5 24H4.5C3.70435 24 2.94129 23.6839 2.37868 23.1213C1.81607 22.5587 1.5 21.7956 1.5 21V13.5C1.5 12.7044 1.81607 11.9413 2.37868 11.3787C2.94129 10.8161 3.70435 10.5 4.5 10.5H12V4.5C12 3.30653 12.4741 2.16193 13.318 1.31802C14.1619 0.474106 15.3065 0 16.5 0C17.6935 0 18.8381 0.474106 19.682 1.31802C20.5259 2.16193 21 3.30653 21 4.5V10.5C21 10.6989 20.921 10.8897 20.7803 11.0303C20.6397 11.171 20.4489 11.25 20.25 11.25C20.0511 11.25 19.8603 11.171 19.7197 11.0303C19.579 10.8897 19.5 10.6989 19.5 10.5V4.5C19.5 3.70435 19.1839 2.94129 18.6213 2.37868C18.0587 1.81607 17.2956 1.5 16.5 1.5Z",
    fill: "#1C2026"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2849_6618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockIcon);
export default __webpack_public_path__ + "static/media/unlock-icon.b359b1b7cd46cb4ec063e70c139c5385.svg";
export { ForwardRef as ReactComponent };